import { Injector } from "@angular/core";
import { AutoUploadNode } from "../../AutoUploadNode";
import { AutoUploadEntityEnum } from "../../../AutoUploadEntityEnum";
import { ServiceEnum } from "../../../ServiceEnum";
import { BaseNode } from "../../BaseNode";
import { ATCcodeEntity } from "../../../Data/MedicinalProductData/ATCcodeEntity";
import { TreeNodeATCCodeList } from "../../Art57Node/ListEntity/TreeNodeATCCodeList";
import { environment } from "../../../../../../environments/environment";


export class ATCcodeAutoUploadEntity extends AutoUploadNode {
    useHist: boolean = false;
    constructor(injector: Injector,
        labelTemplate: string,
        parent: BaseNode,
        model: any,
        useHist: boolean, 
        disableAutoUpload: boolean, 
        cloningNode: boolean) {
        const createChildTemplateparams = { nodeType: 2 };
        super(injector, labelTemplate, ATCcodeEntity, useHist ? AutoUploadEntityEnum.atccodeHist : AutoUploadEntityEnum.atccode, ServiceEnum.MedicinalProducts, parent, model, TreeNodeATCCodeList, false, disableAutoUpload, cloningNode, createChildTemplateparams);
        this.labelNodeName = 'ATC Code';
        this.useHist = useHist;
      }

    public getListItem(): any[] {
        return [this.data.model.atccode];
    }

  override cloneNode(newParent: BaseNode): BaseNode|undefined {
    let clonedNode: ATCcodeAutoUploadEntity =
      new ATCcodeAutoUploadEntity(
        this.ioc!,
        this.labelTemplate,
        newParent,
        this.data.model,
        false,
        this.isLoaded,
        true
      );

    clonedNode.loadEntity();
    clonedNode.isLoading = false;

    clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
    clonedNode.refreshLabel();
    clonedNode.expanded = (this.expanded && environment.userPreferences.autoexpandNodesOnCloning) || environment.userPreferences.alwaysAutoexpandNodes;

    this.children?.forEach((child) => {
      let childToClone = child as BaseNode;
      let clonedChildren = childToClone.cloneNode(clonedNode);
      if (clonedChildren) {
          clonedNode.children?.push(clonedChildren);
          clonedChildren.refreshLabel();
      }
    });

    clonedNode.cloningNode = false;
    return clonedNode;
  }

}